export default __webpack_public_path__ + "static/grad-pricing-old-left-d3bc61d28530bfd9dd17b9afb41e0dc9.png";